
<template>
    <div class="xingluo-components-page-bottom flex-column">

			<div class="xingluo-components-page-bottom-top">
				<div>
					<img class="xingluo-components-page-bottom-logo" src="https://xl.linkstars.com/asset/img/xingluo-components/xingluo-components-page-bottom-logo.png" alt="logo">
				</div>

				<div>
					<div class="xingluo-components-page-bottom-friendship">
						<span class="xingluo-components-page-bottom-friendship-title">友情链接</span>
						<a class="xingluo-components-page-bottom-a" href="https://www.linkstars.com/">首页</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/solutions/cases'">成功案例</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/solutions/services'">创作者服务</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/list/list'">商品总库</a>
						<a class="xingluo-components-page-bottom-a" :href="openapi">开放平台</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/solutions/special_hx'">合作项目</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/help/'">帮助中心</a>
						<a class="xingluo-components-page-bottom-a" :href="domain + '/admin/#/my/myinfo'" target="_blank">用户中心</a>
					</div>
					<div class="xingluo-components-page-bottom-friendship">
						<span class="xingluo-components-page-bottom-friendship-title">联系我们</span>
						地址：北京市丰台区洋桥12号院天路蓝图底商
					</div>
				</div>
				
				<div class="mar-r30 flex-column">
					<img class="xingluo-components-page-bottom-xingluoxinxuan" src="https://xl.linkstars.com/asset/img/xingluo-components/xingluoguandian.png">
					星罗星观点
				</div>
				<div class="flex-column">
					<img class="xingluo-components-page-bottom-xingluoxinxuan bor-rad" src="https://xl.linkstars.com/asset/img/xingluo-components/xingluoxiingxuan.png">
					星罗星选小程序
				</div>
			</div>

    	<div class="xingluo-components-page-bottom-reserve">@CopyRight  2019-2020 星罗www.linkstars.com
				| <a class="xingluo-components-page-bottom-reserve-a" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鲁ICP备16030504号-1</a>
				| 许可证号鲁B2-20200192 | 
				<img class="xingluo-components-page-bottom-reserve-icon" src="https://xl.linkstars.com/asset/img/xingluo-components/luwangwen.png">
				<a class="xingluo-components-page-bottom-reserve-a" href="http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/bf13fbc12d7844b686cbf5b5100e703b" target="_blank">鲁网文〔2020〕3486-062号</a>
			</div> 
    </div>
</template>
<script>
export default {
	name: "xingluo-components-page-foot",
	data() {
		return {
			domain: 'https://xl.linkstars.com',    //域名地址
    	openapi: 'https://openapi.linkstars.com/doc/home/' //开放api
		}
	},
	mounted (){
	},
	methods: {	
	}
}
</script>
<style scoped>
.xingluo-components-page-bottom{
	background: #1F232B;
	width: 100%;
	font-size: 14px;
	color: #999999;
}
.xingluo-components-page-bottom-top{
	display: flex;
	justify-content: space-between;
	width: 1200px;
	padding: 35px 0 25px 0;
}
.xingluo-components-page-bottom-logo{
	width: 171px;
}
.xingluo-components-page-bottom-friendship{
	margin: 20px 18px 0 42px;
	font-size: 14px;
}
.xingluo-components-page-bottom-friendship-title{
	margin-right: 20px;
	font-size: 16px;
	color: #fff;
}
.xingluo-components-page-bottom-a{
	display: inline-block;
	margin-right: 15px;
	font-size: 14px;
	text-decoration: none;
	color: #999999;
}
.xingluo-components-page-bottom-a:first-child{
	width: 70px;
}
.xingluo-components-page-bottom-a:hover{
	color: #ffffff;
}
.xingluo-components-page-bottom-xingluoxinxuan{
	width: 80px;
	margin-bottom: 8px;
}
.xingluo-components-page-bottom-reserve{
	background: #191C23;
	height: 50px;
	width: 100%;
	line-height: 50px;
	text-align: center;
}
.xingluo-components-page-bottom-reserve-a{
	display: inline-block;
	font-size: 14px;
	text-decoration: none;
	color: #999999;
}
.xingluo-components-page-bottom-reserve-a:hover{
	color: #ffffff;
}
.xingluo-components-page-bottom-reserve-icon{
	width: 24px;
	vertical-align: middle;
}
.mar-r30{
	margin-right: 30px;
}
.bor-rad{
	border-radius: 100%;
}
.flex-column{
	display: flex;
	align-items: center;
	flex-direction: column;
}
</style>